export default function IconChart() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-f56d654c-b294-4274-96c8-8079fb17cfc3"
      data-name="Layer 2"
      viewBox="0 0 28.087 23.739"
    >
      <defs>
        <style>
          {
            ".uuid-ec2b29e7-0a8c-47a9-ada6-5d457a99cc22{fill:none;stroke:var(--color-primary);stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"
          }
        </style>
      </defs>
      <g id="uuid-8d653d89-50c2-44c3-9923-e13d3637ec21" data-name="Layer 1">
        <path
          d="M1 14.043h8.696v8.696H1zM18.391 1h8.696v21.739h-8.696z"
          className="uuid-ec2b29e7-0a8c-47a9-ada6-5d457a99cc22"
        />
        <path
          d="M9.696 7.522h8.696v15.217H9.696z"
          className="uuid-ec2b29e7-0a8c-47a9-ada6-5d457a99cc22"
        />
      </g>
    </svg>
  );
}
